






import {Component, Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import {Editor} from '@tiptap/vue-2';
import TooltipIconButton from '@/components/button/TooltipIconButton.vue';

@Component({
  components: {TooltipIconButton},
  mixins: [InputMixin]
})
export default class EditorHyperLink extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: null}) private editor: Editor;

  private readonly LINK_NAME: string = 'link';

  get getActiveClass() {
    return { 'is-active': this.editor.isActive(this.LINK_NAME) };
  }

  private handleClick() {
    if (this.editor.isActive(this.LINK_NAME)) {
      this.editor.chain().focus().extendMarkRange(this.LINK_NAME).unsetLink().run();
      return;
    }

    this.$modal.showInputUrlDialog({
       previousUrl: this.editor.getAttributes(this.LINK_NAME).href,
       onConfirm: (url: string) => {
         this.editor.chain().focus().extendMarkRange(this.LINK_NAME).setLink({href: url}).run();
       }
    });
  }
}
